import type { ActionConfig, ReservationConfig } from "../shared/action.types";
import type { Asset } from "../shared/asset.types";
import type { LocalizedText } from "../shared/localized-text.types";
import type { Money } from "../shared/money.types";

export enum ServiceCategory {
  FOOD = "FOOD",
  CRAFS = "CRAFS",
  WORKSHOP = "WORKSHOP",
  EVENT = "EVENT",
  EXPERIENCE = "EXPERIENCE",
  OTHER = "OTHER",
}

export type ServiceStatus =
  | "available"
  | "temporarily-unavailable"
  | "coming-soon"
  | "on-request";

export interface Service {
  id: string;
  slug: string;
  name: LocalizedText;
  description?: LocalizedText;
  images?: Asset[];
  category: ServiceCategory;
  price?: Money;
  priceFrom?: Money;
  durationMinutes?: number;
  unit?: LocalizedText;
  availability?: LocalizedText;
  status: ServiceStatus;
  featured?: boolean;
  primaryAction?: ActionConfig;
  /** @deprecated Use primaryAction for new V2 integrations. */
  request?: ActionConfig;
  reservation?: ReservationConfig;
  gallery?: Asset[];
  order?: number;
  tags?: LocalizedText[];
}

export interface ServiceCatalog {
  title?: LocalizedText;
  services: Service[];
}
